import { useContext } from "react";
import { useNavigate } from "@tanstack/react-router";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useSaveOrder } from "../../state/draftOrderSaveState";
// MUI
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const CreateOrderBtn = ({ order, staffInfo }) => {
  const navigate = useNavigate();
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const isBlocked = staffInfo.staff.blocked === "Yes" ? true : false;

  //  Create and Save the new order
  const {
    mutate: saveOrder,
    isSuccess: saveSuccess,
    data: saveData,
    isPending,
  } = useSaveOrder();

  // Create Order if it is new
  const createOrder = () => {
    saveOrder({
      data: {
        filter: order.data.filter,
        order: order.data.order,
        staff: order.data.staff,
      },
    });
  };

  // Do this on save order success
  const saveSuccessFunc = () => {
    navigate({ to: `/request/${saveData.data.data.data.data.order.no}` });
  };

  // Do this on save order error
  const saveErrorFunc = () =>
    setAlertNotification({
      message: `Error: ${saveData.data.status}: ${saveData.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(
    saveSuccess,
    saveData,
    saveData?.data?.status,
    saveSuccessFunc,
    saveErrorFunc,
  );

  return (
    <>
      <Button
        variant="contained"
        onClick={createOrder}
        sx={{ width: { xs: "100%", md: "auto" } }}
        disabled={isPending || isBlocked}
      >
        {isPending ? "Loading.." : "Start Request"}
      </Button>
      {isBlocked && (
        <Typography sx={{ pt: 2, color: "red" }}>
          You user is blocked from placing requests. Please contact your line
          manager.
        </Typography>
      )}
    </>
  );
};
